import { Injectable } from "@angular/core";
import {Adapter} from "./adapter"
import { EventDetail } from "../_interfaces/eventDetail";
import { EventFormatterService } from "../services/event-formatter.service";

export interface EventAuthor {
    id: number;
    firstName: string;
    lastName: string;
}

export class Event {
    
    constructor(
        public id: number,
        public typeId: string, 
        public entityType: string,
        public entityId: number,
        public properties: any, 
        public date: Date,
        public details: EventDetail[] = [],
        public author:EventAuthor
        ) {}
}

@Injectable({
    providedIn: "root",
})

export class EventAdapter implements Adapter<Event> {

    constructor(private eventFormatterService: EventFormatterService) {}

    adapt(item: any): Event {
        
        const details = this.eventFormatterService.formatEventDetails(item.properties, item.type_id);

        return new Event(
            item.id,
            item.type_id,
            item.entity_type,
            item.entity_id,
            item.properties,
            new Date(item.date),
            details,
            {
                id: item.author?.id,
                firstName: item.author?.firstname,
                lastName: item.author?.lastname
            }
        );
    }

    adaptToApi(event: Event): any {
        return {
            type_id: event.typeId,
            entity_type: event.entityType,
            entity_id: event.entityId,
            properties: event.properties,
            created_at: event.date,
            
        }
    }
}